export function displayFromMention(display) {
  return `@${display}`;
}

export function hasMentionMarkup(value) {
  return /@\[/.test(String(value || ''));
}

function mentionMarkupRegex() {
  return /@\[([^\]]+)\]\(([^)]+)\)/g;
}

export function toMentionPlainText(markup) {
  return String(markup || '').replace(mentionMarkupRegex(), (_, display) =>
    displayFromMention(display)
  );
}

function mentionAnchors(markup) {
  const regex = mentionMarkupRegex();
  const anchors = [];
  let match = regex.exec(markup);

  while (match) {
    anchors.push({
      markup: match[0],
      plain: displayFromMention(match[1])
    });
    match = regex.exec(markup);
  }

  return anchors;
}

// MentionsInput shows @Name in the textarea but stores @[Name](id) in form state.
// Re-attach those markup tokens wherever their display text still appears.
export function reapplyMentionMarkup(markup, plainText) {
  const anchors = mentionAnchors(markup);

  if (anchors.length === 0) {
    return plainText;
  }

  let cursor = 0;
  let result = '';

  for (const mention of anchors) {
    const index = plainText.indexOf(mention.plain, cursor);

    if (index === -1) {
      continue;
    }

    result += plainText.slice(cursor, index);
    result += mention.markup;
    cursor = index + mention.plain.length;
  }

  return `${result}${plainText.slice(cursor)}`;
}

export function valueFromPlainText(formValue, plainText) {
  const expectedPlain = hasMentionMarkup(formValue)
    ? toMentionPlainText(formValue)
    : formValue;

  if (plainText === expectedPlain) {
    return formValue;
  }

  if (!hasMentionMarkup(formValue)) {
    return plainText;
  }

  return reapplyMentionMarkup(formValue, plainText);
}
